import { type APIReferenceAttributes } from '@ardoq/api-types';
import { modelOperations } from '@ardoq/core';
import {
  getReferenceTypesWithDefaults,
  type WorkspaceAndModelLookup,
} from '@ardoq/data-model';
import { scopeDataOperations } from '@ardoq/scope-data';

export const getReferenceTypeNameFromModels = (
  reference: APIReferenceAttributes,
  workspaceAndModel: WorkspaceAndModelLookup
): string | null => {
  const found = scopeDataOperations.getWorkspaceAndModel(
    workspaceAndModel,
    reference.rootWorkspace
  );
  if (!found) return null;
  return modelOperations.getRefTypeName(
    getReferenceTypesWithDefaults(found.model),
    reference.type
  );
};
